<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AkXBt/tc-custom/9781683830467.jpg?1703710456676" alt="This image is the cover for the book Star Trek: The Klingon Empire, Hidden Universe Travel Guides"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Star Trek: The Klingon Empire, Hidden Universe Travel Guides
      </h1>
      <p class="bookDescription body article font2">
        <b>Explore the homeworld and vast dominion of <i>Star Trek</i>’s formidable Klingons in this “fun and engaging” travel guide full of “fascinating facts”(<i>Starburst Magazine</i>).</b><br/><br/> nuqneH! Bored of standard vacations to places like Risa or Wrigley’s Pleasure Planet? Want to discover a unique and ancient culture not bound by standard niceties and social mores? Then Qo’noS and the vast Klingon Empire are for you!<br/><br/> This one-of-a-kind travel guide will give you all the information you need to plan, enjoy, and survive your trip to the very heart of Klingon territory, from an overview of Klingon history to tips on what to wear (fur and leather are very popular) to a glossary of important phrases like “mamI' DaneH'a'? nItebHa' mamI' DaneH'a'?” (Would you like to dance with me?). Every major location in the Klingon Empire is covered in depth, with tips on where to eat (you’ve not lived until you’ve eaten Klingon skull stew), how best to get to and from your chosen destination, and what to do if you find yourself challenged to a bat’leth battle to the death. Locations include the homeworld Qo’noS and its famous locales such as the First City, the Caves of No’mat, the Hamar Mountains, and the city of Krennla, plus neighboring moons Corvix and Praxis, and many, many more must-see areas. The book also features exclusive maps and illustrations that bring to life the Klingon Empire and form the perfect reference guide for any visitor. So what are you waiting for? Qapla’!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Insight Editions
      </h2>
      
      <p class="authorDescription body article">Scott Campbell, sometimes known as Scott C., is the creator of the GREAT SHOWDOWNS online series and Double Fine Action Comics. He was art director and concept artist at Double Fine Productions on such games as Psychonauts, Brutal Legend, and Broken Age. His illustrated picture books include Zombie in Love, Zombie in Love 2 + 1, East Dragon West Dragon, XO, OX: A Love Story, Bob Dylan’s If Dogs Run Free and Hug Machine, in which he has written the words as well as created the pictures. Scott lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Insight Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a7720d7e